import { NivelHotel } from "./nivel-hotel";
import { TipoHabitacionHotel } from "./tipo-habitacion-hotel";

export class HabitacionHotel{
    
    public constructor(
        public id: String = "",
        public codigo: String = "",
        public nombre: String = "",
        public detalle: String = "",
        public precio: number = 0,

        
        public nivel_hotel_id: String = "",
        public tipo_habitacion_id: String = "",
        
        public status: String = "",
        public usuario_id: String = "",
        public empresa_id: String = "",

        public nivelHotel: NivelHotel = new NivelHotel(),
        public tipohabitacion: TipoHabitacionHotel = new TipoHabitacionHotel(),
    ){}

}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/habitacion-hotel.ts